import clsx from 'clsx';
import * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

/** Shared visual card used by the early page preview and dnd-kit's drag overlay. */
export function DragPreviewCard(props: {
    icon?: keyof typeof Icon;
    label: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    ref?: React.Ref<HTMLDivElement>;
    labelRef?: React.Ref<HTMLDivElement>;
}): React.ReactElement {
    const { icon, label, className, style, ref, labelRef } = props;
    const IconComponent = icon ? Icon[icon] : null;

    return (
        <div
            ref={ref}
            className={clsx(
                'flex cursor-grabbing items-center justify-center gap-2 rounded-lg border border-neutral-subtle bg-neutral-surface-subtle px-4 py-2 whitespace-nowrap text-base shadow-subtle',
                className
            )}
            style={style}
        >
            {IconComponent ? <IconComponent className="size-3.5" /> : null}
            <div ref={labelRef} className="text-ui-action">
                {label}
            </div>
        </div>
    );
}
